/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useContext,
  useReducer,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import { getError } from "../LoadingError/Utils";
import { Store } from "../Store";
import { useNavigate, useLocation, Link } from "react-router-dom";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";
import L from "leaflet";
import { format } from "date-fns";
import SendIcon from "@mui/icons-material/Send";
import { MapContainer, Marker, TileLayer, ZoomControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import {
  Box,
  Menu,
  MenuItem,
  Modal,
  Tooltip,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
} from "@mui/material";
import LoadingBox from "../LoadingError/LoadingBox";
import MessageBox from "../LoadingError/MessageBox";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination } from "swiper/modules";

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

const reducer2 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loading: true };
    case "FETCHED":
      return { ...state, dataUser: action.payload, loading: false };
    case "FETCH_FAILED":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const reducer3 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingComments: true };
    case "FETCHED":
      return { ...state, dataComments: action.payload, loadingComments: false };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingComments: false,
        errorComments: action.payload,
      };
    default:
      return state;
  }
};

const reducer4 = (state, action) => {
  switch (action.type) {
    case "DELETE_REQUEST":
      return { ...state, loadingDel: true };
    case "DELETE_SUCCESS":
      return { ...state, loadingDel: false };
    case "DELETE_FAIL":
      return { ...state, loadingDel: false };
    default:
      return state;
  }
};

const reducer5 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingAllContactList: true };
    case "FETCHED":
      return {
        ...state,
        dataAllContactList: action.payload,
        loadingAllContactList: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingAllContactList: false,
        errorAllContactList: action.payload,
      };
    default:
      return state;
  }
};

const reducer6 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingSpecificPost: true };
    case "FETCHED":
      return {
        ...state,
        dataSpecificPost: action.payload,
        loadingSpecificPost: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingSpecificPost: false,
        errorSpecificPost: action.payload,
      };
    default:
      return state;
  }
};

const reducer7 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingReplyComments: true };
    case "FETCHED":
      return {
        ...state,
        dataReplyComments: action.payload,
        loadingReplyComments: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingReplyComments: false,
        errorReplyComments: action.payload,
      };
    default:
      return state;
  }
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  borderRadius: "0.5rem",
  outline: "none",
  // boxShadow: "0 2px 20px #F95C3D",
  p: 4,
};

const modalAllCommentStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  height: "90vh",
  bgcolor: "background.paper",
  border: "0.1px solid gainsboro",
  borderRadius: "1rem",
  boxShadow: "1px 2px 1px gainsboro",
  p: 4,
};

const readMoreStyle = {
  color: "rgb(107 114 128)",
  cursor: "pointer",
};

const suggestedSlide = [
  {
    slides: 1,
    photo: "../../images/groupinformation.png",
    title: "Best Prices & Deals",
    detail:
      "Find your favorite Things at ease and best prices with exclusive deals only on SiapHub.",
  },
  {
    slides: 2,
    photo: "../../images/siaphub_logo_clean.png",
    title: "Best Prices & Deals",
    detail:
      "Find your favorite Things at ease and best prices with exclusive deals only on SiapHub.",
  },
];

const bounds = [
  [-90, -180],
  [90, 180],
];

function DetailPost() {
  const { state } = useContext(Store);
  const { userInfo } = state;
  const [, setShowPostModal] = useState(false);
  const [, setPostModalKey] = useState("");
  const [, setPostModalData] = useState("");
  const [comment, setComment] = useState("");
  const [commentPlaceholder, setCommentPlaceholder] = useState(
    "Add your comment..."
  );
  const [showModalComment, setShowModalComment] = useState(false);
  const [showAllComments, setShowAllComments] = useState(false);
  const [page, setPage] = useState(1);
  const [idxImage, setIdxImage] = useState(0);
  const divRef = useRef(null);

  const toCommentRef = useRef(null);
  const toCommentRefMobile = useRef(null);
  const toInputCommentRef = useRef(null);
  const toInputCommentRefMobile = useRef(null);

  const loc = useLocation();
  const navigate = useNavigate();
  const tempPost = loc.state;
  const searchParams = new URLSearchParams(loc.search);
  const postDetailId = searchParams.get("postId");

  const selectedImageRef = useRef(null);

  let [post, setPost] = useState(
    tempPost && tempPost.post ? tempPost.post : null
  );

  const [animate, setAnimate] = useState(false);
  const [socialMediaOptions, setSocialMediaOptions] = useState(true);
  const [showReportModal, setShowReportModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const [totalLikes, setTotalLikes] = useState(
    parseInt(post?.total_likes || 0)
  );
  const [likes, setLikes] = useState(
    (post && post.user_liked?.user_liked) || 0
  );

  const createdDate = new Date(post?.created_at);

  const [, setShowModalContact] = useState(false);

  const [setPosition] = useState(null);
  const textareaRef = useRef(null);

  const [selectedImage, setSelectedImage] = useState(
    post?.images?.[0] || "../images/default_post_2.png"
  );
  const isNull = !!post?.images;

  const imagess = post?.images || [];
  const [hovered, setHovered] = useState(false);

  const [anchorElPost, setAnchorElPost] = useState(null);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);

  const edits = ["Update Post", "Delete Post"];
  const editsAsAdmin = ["Delete Post"];
  const editsAsUser = ["Report Post"];

  const [isLoadingImg, setIsLoadingImg] = useState(true);

  //Add Comment Button Flagging
  const [isSubmitting, setIsSubmitting] = useState(false);

  //Reply Comment
  const [dataReplyComment, setDataReplyComment] = useState(null);

  const [visibleReplies, setVisibleReplies] = useState({});
  const [replyComments, setReplyComments] = useState({}); // Store fetched replies

  //Add Comment Success Flag

  const handleShowAllComments = () => {
    setShowAllComments(true);
  };

  const handleCloseCommentsModal = () => {
    setShowAllComments(false);
  };

  const [dispatch] = useReducer(reducer, {
    loadingUpdate: false,
  });

  const [{ loading, dataUser }, dispatch2] = useReducer(reducer2, {
    dataUser: [],
    loading: true,
    error: "",
  });

  const [{ loadingComments, errorComments, dataComments }, dispatch3] =
    useReducer(reducer3, {
      dataComments: [],
      loadingComments: true,
      errorComments: "",
    });

  const [{ loadingDel }, dispatch4] = useReducer(reducer4, {
    loadingDel: false,
  });

  const [{ dataAllContactList }, dispatch5] = useReducer(reducer5, {
    dataAllContactList: [],
    loadingAllContactList: true,
    errorAllContactList: "",
  });

  const [{ dataSpecificPost }, dispatch6] = useReducer(reducer6, {
    dataSpecificPost: [],
    loadingSpecificPost: true,
    errorSpecificPost: "",
  });

  const [
    { loadingReplyComments, errorReplyComments, dataReplyComments },
    dispatch7,
  ] = useReducer(reducer7, {
    dataReplyComments: [],
    loadingReplyComments: true,
    errorReplyComments: "",
  });

  const handleToCommentClick = () => {
    // Scroll to the element with the ID "toComment"
    toCommentRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    toInputCommentRef.current.focus();
  };
  const handleToCommentClickMobile = () => {
    // Scroll to the element with the ID "toComment"
    toCommentRefMobile.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
    toInputCommentRefMobile.current.focus();
  };

  useEffect(() => {
    if (!post && postDetailId === null) {
      navigate("/");
    }

    const shouldScrollToComments = loc.state && loc.state.scrollToComments;
    console.log(shouldScrollToComments);

    // Scroll to the element with the ID "toComment" only if shouldScrollToComments is true
    if (shouldScrollToComments && toCommentRef.current) {
      toCommentRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      toInputCommentRef.current.focus();
      toCommentRefMobile.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
      toInputCommentRefMobile.current.focus();
    }
  }, [postDetailId, dataComments]);

  const markerIcon = new L.Icon({
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    shadowSize: [41, 41],
  });

  L.Marker.prototype.options.icon = markerIcon;

  const markerRef = useRef(null);

  useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setPosition(marker.getLatLng());
        }
      },
    }),
    [setPosition]
  );

  const nominal = post && post.price ? post.price : "";
  const price =
    post &&
    post.price &&
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: post.abbreviation ? post.abbreviation : "IDR",
      maximumFractionDigits: 0,
    }).format(nominal);

  const formattedDate = createdDate.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });

  const date_diff_indays = function (date1, date2) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor(
      (Date.UTC(
        dt2.getFullYear(),
        dt2.getMonth(),
        dt2.getDate(),
        dt2.getHours(),
        dt2.getMinutes(),
        dt2.getSeconds()
      ) -
        Date.UTC(
          dt1.getFullYear(),
          dt1.getMonth(),
          dt1.getDate(),
          dt1.getHours(),
          dt1.getMinutes(),
          dt1.getSeconds()
        )) /
      1000
    );
  };

  const UploadDate = ({ timestamp }) => {
    let currentDate = new Date();
    let uploadDate = new Date(timestamp);

    let diffDate = date_diff_indays(uploadDate, currentDate);
    let date = "";
    if (diffDate >= 604800) {
      date = Math.floor(diffDate / 604800) + "w";
      return date;
    } else if (diffDate >= 86400) {
      date = Math.floor(diffDate / 86400) + "d";
      return date;
    } else if (diffDate >= 3600) {
      date = Math.floor(diffDate / 3600) + "h";
      return date;
    } else if (diffDate >= 60) {
      date = Math.floor(diffDate / 60) + "m";
      return date;
    } else {
      if (diffDate < 0) {
        diffDate = 0;
      }
      date = diffDate + "s";
      return date;
    }
  };

  function handleUsername(e) {
    navigate(`/${post.username}`, { state: { e } });
  }

  function SetProfilePicture() {
    const isNull = post.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPP />;
    } else {
      return <ProfilePicture />;
    }
  }

  function DefaultPP() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-12 h-12"
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function ProfilePicture() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-12 h-12"
        src={post.picture}
        alt="profilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function SetProfilePictureDataUser() {
    const isNull = dataUser.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPPDataUser />;
    } else {
      return <ProfilePictureDataUser />;
    }
  }

  function DefaultPPDataUser() {
    return (
      <img
        className="rounded-full w-12 h-12"
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  useEffect(() => {
    const img = new Image();
    img.src = dataUser.picture;
    img.onload = () => setIsLoadingImg(false);
  }, [dataUser.picture]);

  function ProfilePictureDataUser() {
    return (
      <>
        {isLoadingImg ? (
          <div
            className={`rounded-full w-10 h-10 ${isLoadingImg ? "animate-pulse bg-slate-400" : ""
              }`}
          ></div>
        ) : (
          <img
            className="rounded-full w-10 h-10"
            src={dataUser.picture}
            alt="profilepicture"
            referrerPolicy="no-referrer"
          />
        )}
      </>
    );
  }

  function handleOpenPersonalChat() {
    navigate("/all_chat", { state: { post } });
  }

  useEffect(async () => {
    if (userInfo === null) {
      navigate("/signin");
      return;
    }

    dispatch2({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/me`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      dispatch2({
        type: "FETCHED",
        payload: data.data,
      });
    } catch (error) {
      dispatch2({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      toast.error(getError(error));
    }
  }, []);

  useEffect(async () => {
    if (isSubmitting === false) {
      dispatch3({
        type: "FETCHING",
      });
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN
          }/api/posts/getComment?postId=${postDetailId || post.id}`,
          {
            auth: {
              username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
              password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
            },
          }
        );
        dispatch3({
          type: "FETCHED",
          payload: data.data,
        });
      } catch (error) {
        dispatch3({
          type: "FETCH_FAILED",
          payload: error.message,
        });
        // toast.error(getError(error));
      }
    }
  }, [loading, loadingDel, postDetailId, isSubmitting]);

  // Get Reply Comment
  const handleReplyComment = async (commentId, index) => {
    // Toggle replies visibility
    setVisibleReplies((prevState) => ({
      ...prevState,
      [index]: !prevState[index], // Toggle visibility for this comment
    }));

    // Fetch replies if they are not already loaded
    if (!visibleReplies[index] && !replyComments[commentId]) {
      dispatch7({ type: "FETCHING" });

      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN
          }/api/posts/getAllReplies?commentId=${commentId}&postId=${postDetailId || post.id
          }`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );
        dispatch7({ type: "FETCHED", payload: data.data });
        setReplyComments((prevState) => ({
          ...prevState,
          [commentId]: data.data,
        }));
      } catch (error) {
        dispatch7({ type: "FETCH_FAILED", payload: error.message });
        toast.error(getError(error));
      }
    }
  };

  // useEffect(async () => {
  //   handleReplyComment()
  // }, [loading, loadingDel, postDetailId, isSubmitting]);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handlePreviousClick = () => {
    const currentIndex = imagess.findIndex((image) => image === selectedImage);
    if (currentIndex > 0) {
      setSelectedImage(imagess[currentIndex - 1]);
    } else {
      setSelectedImage(imagess[imagess.length - 1]);
    }
  };

  const handleNextClick = () => {
    const currentIndex = imagess.findIndex((image) => image === selectedImage);
    if (currentIndex < imagess.length - 1) {
      setSelectedImage(imagess[currentIndex + 1]);
    } else {
      setSelectedImage(imagess[0]);
    }
  };

  const fetchMoreUserPosts = async () => {
    if (userInfo === null) {
      navigate("/");
      return;
    }

    dispatch({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/showUserPost?row=10&page=${page}`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      dispatch({
        type: "FETCHED_MORE",
        payload: data.data,
      });
    } catch (error) {
      dispatch({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      toast.error(getError(error));
    }
  };

  const handleScroll = () => {
    const divElement = divRef.current;

    if (divElement) {
      const atBottom =
        divElement.scrollHeight - divElement.scrollTop ===
        divElement.clientHeight;

      if (atBottom) {
        fetchMoreUserPosts();
        setPage(page + 1);
      }
    }
  };

  const handleOpenPostModal = (userPost) => {
    setShowPostModal(true);
    setPostModalKey(userPost.slug);
    setPostModalData(userPost);
  };

  const isVideo = selectedImage ? selectedImage.includes("smpost-v-") : null;
  function SetDefaultImage() {
    if (isNull === "null" || isNull === null) {
      return (
        <div className="relative bg-[#F5F5F5] rounded-md w-[98%] h-[98%] lg:w-[37rem]">
          <img
            className="w-[55rem] h-[30rem] rounded-lg shadow-none items-center  justify-center "
            src="../images/default_post_2.png"
            alt="postImage"
          />

          <div className="absolute top-0 right-0 px-6 py-4">
            <div className="mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip onClick={() => handleButtonClick(post.id)} title="Like">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`hover:opacity-100 ${likes ? "opacity-100 " : "opacity-50"
                    }`}
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    stroke="#e0e0e0"
                    strokeWidth="2"
                  />
                  <path
                    d="M18.7964 6.82289C19.2124 5.7257 20.7866 5.7257 21.2039 6.82289L23.8948 14.277C23.9887 14.5198 24.154 14.7284 24.3689 14.8754C24.5838 15.0223 24.8382 15.1005 25.0985 15.0999H31.7113C32.9333 15.0999 33.4663 16.6208 32.5056 17.3657L27.7998 21.5998C27.589 21.7618 27.435 21.9865 27.3598 22.2415C27.2846 22.4965 27.2921 22.7688 27.3812 23.0193L29.0998 30.3031C29.5183 31.4731 28.1638 32.478 27.1394 31.7578L20.7476 27.7019C20.5287 27.548 20.2677 27.4655 20.0002 27.4655C19.7326 27.4655 19.4716 27.548 19.2527 27.7019L12.8609 31.7578C11.8378 32.478 10.482 31.4718 10.9006 30.3031L12.6191 23.0193C12.7082 22.7688 12.7157 22.4965 12.6405 22.2415C12.5653 21.9865 12.4113 21.7618 12.2005 21.5998L7.49471 17.3657C6.53276 16.6208 7.06833 15.0999 8.28768 15.0999H14.9005C15.1609 15.1007 15.4153 15.0225 15.6303 14.8756C15.8452 14.7286 16.0105 14.5199 16.1042 14.277L18.7964 6.82289Z"
                    stroke={likes ? "none" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill={likes ? "#FFDD43" : "none"}
                  />
                </svg>
              </Tooltip>
            </div>

            <div className="hidden lg:flex mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip onClick={handleToCommentClick} title="Comment">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="opacity-50 hover:opacity-100"
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    fillOpacity="1"
                    stroke="#D1D1D1"
                    strokeWidth="2"
                  />
                  <path
                    d="M20.4751 15.5679V23.4846M16.5168 19.5262H24.4334M20.4751 31.3999C22.8237 31.3999 25.1197 30.7034 27.0725 29.3986C29.0253 28.0938 30.5474 26.2391 31.4462 24.0693C32.345 21.8994 32.5801 19.5117 32.1219 17.2082C31.6637 14.9047 30.5327 12.7888 28.872 11.128C27.2112 9.46727 25.0953 8.33628 22.7918 7.87808C20.4883 7.41988 18.1006 7.65505 15.9307 8.55384C13.7609 9.45263 11.9062 10.9747 10.6014 12.9275C9.29655 14.8803 8.6001 17.1763 8.6001 19.5249C8.6001 21.4882 9.0751 23.3394 9.91954 24.9703L8.6001 31.3999L15.0297 30.0805C16.6606 30.9249 18.5131 31.3999 20.4751 31.3999Z"
                    stroke="black"
                    strokeOpacity="1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Tooltip>
            </div>
            <div className="flex lg:hidden mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip onClick={handleToCommentClickMobile} title="Comment">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="opacity-50 hover:opacity-100"
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    fillOpacity="1"
                    stroke="#D1D1D1"
                    strokeWidth="2"
                  />
                  <path
                    d="M20.4751 15.5679V23.4846M16.5168 19.5262H24.4334M20.4751 31.3999C22.8237 31.3999 25.1197 30.7034 27.0725 29.3986C29.0253 28.0938 30.5474 26.2391 31.4462 24.0693C32.345 21.8994 32.5801 19.5117 32.1219 17.2082C31.6637 14.9047 30.5327 12.7888 28.872 11.128C27.2112 9.46727 25.0953 8.33628 22.7918 7.87808C20.4883 7.41988 18.1006 7.65505 15.9307 8.55384C13.7609 9.45263 11.9062 10.9747 10.6014 12.9275C9.29655 14.8803 8.6001 17.1763 8.6001 19.5249C8.6001 21.4882 9.0751 23.3394 9.91954 24.9703L8.6001 31.3999L15.0297 30.0805C16.6606 30.9249 18.5131 31.3999 20.4751 31.3999Z"
                    stroke="black"
                    strokeOpacity="1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Tooltip>
            </div>

            <div className="mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip onClick={handleCopyLink} title="Share Post">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="opacity-50 hover:opacity-100"
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    fillOpacity="1"
                    stroke="#D1D1D1"
                    strokeWidth="2"
                  />
                  <path
                    d="M21.863 9.63768C22.0168 9.56647 22.1886 9.53764 22.3588 9.55448C22.5291 9.57132 22.6909 9.63315 22.8258 9.73293L31.0468 15.7937C31.1528 15.8718 31.2393 15.971 31.3003 16.0843C31.3612 16.1976 31.3951 16.3223 31.3994 16.4494C31.4038 16.5765 31.3785 16.703 31.3255 16.8199C31.2724 16.9367 31.1929 17.041 31.0925 17.1254L22.8715 24.052C22.7398 24.1629 22.5772 24.2353 22.4031 24.2605C22.2291 24.2857 22.051 24.2628 21.8905 24.1943C21.7299 24.1259 21.5935 24.015 21.4979 23.8748C21.4023 23.7347 21.3515 23.5713 21.3515 23.4044V20.0381C20.9204 20.1073 20.3577 20.2285 19.7 20.4363C18.1052 20.942 15.9476 21.9585 13.7773 24.0174C13.6445 24.1438 13.4738 24.2282 13.2884 24.2591C13.1031 24.29 12.9123 24.2659 12.7419 24.1901C12.5716 24.1143 12.4302 23.9905 12.3369 23.8356C12.2436 23.6807 12.203 23.5023 12.2208 23.3247C12.482 20.6043 13.3187 18.6198 14.4569 17.1895C15.4337 15.9549 16.7613 15.0095 18.2842 14.4638C19.2664 14.1109 20.302 13.9098 21.3515 13.8681V10.4169C21.3512 10.2547 21.399 10.0956 21.4894 9.95778C21.5798 9.82 21.7093 9.70909 21.863 9.63768ZM7.6499 15.6119C7.6499 14.4638 8.13109 13.3626 8.98761 12.5507C9.84412 11.7389 11.0058 11.2828 12.2171 11.2828H15.8709C16.1131 11.2828 16.3455 11.374 16.5168 11.5364C16.6881 11.6987 16.7843 11.919 16.7843 12.1486C16.7843 12.3782 16.6881 12.5985 16.5168 12.7608C16.3455 12.9232 16.1131 13.0144 15.8709 13.0144H12.2171C11.4903 13.0144 10.7933 13.2881 10.2794 13.7752C9.7655 14.2623 9.47678 14.923 9.47678 15.6119L9.47678 26.0019C9.47678 26.6908 9.7655 27.3515 10.2794 27.8386C10.7933 28.3257 11.4903 28.5994 12.2171 28.5994H23.1784C23.9052 28.5994 24.6022 28.3257 25.1161 27.8386C25.63 27.3515 25.9187 26.6908 25.9187 26.0019V24.2702C25.9187 24.0406 26.015 23.8204 26.1863 23.658C26.3576 23.4956 26.5899 23.4044 26.8322 23.4044C27.0744 23.4044 27.3068 23.4956 27.4781 23.658C27.6494 23.8204 27.7456 24.0406 27.7456 24.2702V26.0019C27.7456 27.1501 27.2644 28.2512 26.4079 29.0631C25.5514 29.8749 24.3897 30.3311 23.1784 30.3311H12.2171C11.0058 30.3311 9.84412 29.8749 8.98761 29.0631C8.13109 28.2512 7.6499 27.1501 7.6499 26.0019L7.6499 15.6119Z"
                    fill="black"
                    fillOpacity="1"
                  />
                </svg>
              </Tooltip>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="flex w-full justify-center lg:w-full sticky top-14">
            {imagess.length > 1 ? (
              <div className="flex w-full">
                <div
                  className={`hidden lg:flex flex-col cursor-pointer w-32 rounded-auto h-full relative ${imagess.length > 3 ? "mr-3" : ""
                    }`}
                >
                  {/* PREVIOUS CLICK */}
                  {imagess.length > 3 && (
                    <button
                      className="rounded-full shadow-md hover:bg-[#F5F5F5]"
                      onClick={handlePreviousClick}
                    >
                      <ArrowDropUpIcon />
                    </button>
                  )}
                  <div
                    className={`${imagess.length > 3 ? "overflow-auto h-[21rem] inner" : ""
                      }`}
                    style={{ overflowX: "hidden" }}
                  >
                    {imagess.map((media, index) => {
                      const isVideo = media.includes("smpost-v-"); // Update this to match your naming convention
                      return isVideo ? (
                        <video
                          key={index}
                          ref={
                            selectedImage === media ? selectedImageRef : null
                          }
                          className={`rounded-2xl shadow-none items-center w-24 h-24 justify-center mb-2 flex flex-col ${selectedImage === media
                              ? "border-4 border-[#F95C3D]"
                              : "border"
                            }`}
                          style={{
                            border:
                              selectedImage === media
                                ? "4px solid #F95C3D"
                                : "0.1px solid gainsboro",
                          }}
                          src={media}
                          onClick={() => {
                            handleImageClick(media);
                            setIdxImage(index);
                          }}
                          controls
                        />
                      ) : (
                        <img
                          key={index}
                          ref={
                            selectedImage === media ? selectedImageRef : null
                          }
                          className={`rounded-2xl shadow-none items-center w-24 h-24 justify-center mb-2 flex flex-col ${selectedImage === media
                              ? "border-4 border-[#F95C3D]"
                              : "border"
                            }`}
                          style={{
                            border:
                              selectedImage === media
                                ? "4px solid #F95C3D"
                                : "0.1px solid gainsboro",
                          }}
                          src={media}
                          alt={`postImage${index}`}
                          onClick={() => {
                            handleImageClick(media);
                            setIdxImage(index);
                          }}
                        />
                      );
                    })}
                  </div>

                  {/* NEXT CLICK */}
                  {imagess.length > 3 && (
                    <button
                      className="rounded-full shadow-md hover:bg-[#F5F5F5]"
                      onClick={handleNextClick}
                    >
                      <ArrowDropDownIcon />
                    </button>
                  )}
                </div>
                <div className="flex-col w-full h-[75vh]">
                  <div
                    className="w-full h-[75vh] relative bg-[#ffffff] rounded-2xl"
                    style={{
                      border: "0.1px solid gainsboro",
                    }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                  >
                    {isVideo ? (
                      <video
                        className="w-full h-full object-contain rounded-2xl shadow-none"
                        src={selectedImage} // Assuming selectedImage is the video URL if it's a video
                        controls
                        autoPlay
                        loop
                      />
                    ) : (
                      <img
                        className="w-full h-full object-contain rounded-2xl shadow-none"
                        src={selectedImage}
                        alt="postImage"
                      />
                    )}
                    {imagess.length > 1 ? (
                      <div className="">
                        {hovered && (
                          <button
                            className="hidden lg:flex rounded-lg bg-white mr-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute"
                            style={{
                              top: "50%",
                              left: "2%",
                              transform: "translate(0%, -50%)",
                            }}
                            onClick={handlePreviousClick}
                          >
                            <ArrowBackIosNewIcon
                              style={{ fontSize: "medium" }}
                            />
                          </button>
                        )}

                        {hovered && (
                          <button
                            className="hidden lg:flex rounded-lg bg-white ml-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute"
                            style={{
                              top: "50%",
                              right: "2%",
                              transform: "translate(0%, -50%)",
                            }}
                            onClick={handleNextClick}
                          >
                            <ArrowForwardIosIcon
                              style={{ fontSize: "medium" }}
                            />
                          </button>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* icons desktop*/}
                  <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
                    <div className="flex card-icons items-center">
                      <div className="flex">
                        <Tooltip
                          onClick={() => handleButtonClick(post.id)}
                          title="Like"
                          className="cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                              }`}
                            viewBox="0 0 20 20"
                            fill={likes ? "#FFDD43" : "currentColor"}
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                          </svg>
                        </Tooltip>

                        <p className="ml-2">{totalLikes}</p>
                      </div>
                      <div className="flex ml-4">
                        <Tooltip
                          onClick={handleToCommentClick}
                          title="Comment"
                          className="cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </Tooltip>
                        <p className="ml-2">{post.total_comments}</p>
                      </div>
                      <div className="flex ml-4">
                        <Tooltip
                          onClick={handleCopyLink}
                          title="Share Post"
                          className="cursor-pointer"
                        >
                          <svg
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                              fill="currentColor"
                            />
                          </svg>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex w-full">
                <div className="flex-col w-full h-[75vh]">
                  <div
                    className="w-full h-[85vh] relative bg-[#ffffff] rounded-2xl"
                    style={{
                      border: "0.1px solid gainsboro",
                    }}
                  >
                    {isVideo ? (
                      <video
                        className="w-full h-full object-contain rounded-2xl shadow-none"
                        src={selectedImage} // Assuming selectedImage is the video URL if it's a video
                        controls
                        autoPlay
                        loop
                      />
                    ) : (
                      <img
                        className="w-full h-full object-contain rounded-2xl shadow-none"
                        src={selectedImage}
                        alt="postImage"
                      />
                    )}
                  </div>
                  {/* icons desktop*/}
                  <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
                    {/* <div className="flex card-icons items-center">
                      <div className="flex">
                        <Tooltip
                          onClick={() => handleButtonClick(post.id)}
                          title="Like"
                          className="cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                              animate ? "scale-150" : ""
                            }`}
                            viewBox="0 0 20 20"
                            fill={likes ? "#FFDD43" : "currentColor"}
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                          </svg>
                        </Tooltip>

                        <p className="ml-2">{totalLikes}</p>
                      </div>
                      <div className="flex ml-4">
                        <Tooltip
                          onClick={handleToCommentClick}
                          title="Comment"
                          className="cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </Tooltip>
                        <p className="ml-2">{post.total_comments}</p>
                      </div>
                      <div className="flex ml-4">
                        <Tooltip
                          onClick={handleCopyLink}
                          title="Share Post"
                          className="cursor-pointer"
                        >
                          <svg
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                              fill="currentColor"
                            />
                          </svg>
                        </Tooltip>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      );
    }
  }

  function ShowReplyCommentPreview({ dataReplyComment }) {
    if (dataReplyComment !== null) {
      return (
        <div className="flex p-2 my-2 bg-[#F5F5F5] rounded-lg">
          <div className="mr-2">
            <SetReplyCommentProfilePicture data={dataReplyComment} />
          </div>
          <div className="flex flex-col" style={{ flex: 1 }}>
            <div className="flex items-center">
              {userInfo !== null ? (
                <>
                  {dataUser.user_id === dataReplyComment.user_id ? (
                    <a href={`/${dataUser.username}`}>
                      <SetCommentUsername data={dataReplyComment} />
                    </a>
                  ) : (
                    <div
                      onClick={() => handleUsername(dataReplyComment)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <SetCommentUsername data={dataReplyComment} />
                    </div>
                  )}
                </>
              ) : (
                <SetCommentUsername data={dataReplyComment} />
              )}
              {dataReplyComment.verified ? (
                <img
                  className="ml-2 max-h-6"
                  alt="verified"
                  src="../../images/icon_done.png"
                  style={{
                    maxWidth: "20px",
                    maxHeight: "20px",
                  }}
                />
              ) : (
                ""
              )}
              <div className="flex ml-3 text-xs">
                <UploadDate timestamp={dataReplyComment.created_at} />
              </div>

              <div
                style={{
                  marginLeft: "auto",
                }}
              >
                <Tooltip title="Cancel Reply">
                  <CloseTwoToneIcon
                    onClick={() => {
                      setCommentPlaceholder("Add your comment...");
                      setDataReplyComment(null);
                    }}
                    style={{
                      cursor: "pointer",
                      color: "darkgrey",
                    }}
                  />
                </Tooltip>
              </div>
            </div>
            <div>
              <div className="">{dataReplyComment.comment}</div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
  function SetUsername() {
    if (post.username === null) {
      return (
        <p className="leading-tight">
          <div className="flex items-center">
            <span>{post.name}</span>
            <div className="flex items-center ml-2">
              {post.verified ? (
                <img
                  className="w-4 h-4"
                  alt="verified"
                  src="../../images/icon_done.png"
                ></img>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="text-sm text-gray-500 leading-tight">
            {formattedDate}
          </div>
          <div className="text-sm text-gray-500 leading-tight">
            <UploadDate timestamp={post.created_at} />, located in{" "}
            {post.location}{" "}
          </div>
        </p>
      );
    } else {
      return (
        <p className="leading-tight">
          {/* {post.username} */}
          <div className="flex items-center">
            <span>{post.name}</span>
            <div className="flex items-center ml-2">
              {post.verified ? (
                <img
                  className="w-4 h-4"
                  alt="verified"
                  src="../../images/icon_done.png"
                ></img>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="text-sm text-gray-500 leading-tight">
            {formattedDate}
          </div>
          <div className="text-s text-gray-500 leading-tight">
            <UploadDate timestamp={post.created_at} />, located in{" "}
            {post.location}{" "}
          </div>
        </p>
      );
    }
  }

  const SetCommentProfilePicture = ({ data }) => {
    const isNull = data.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPPComment />;
    } else {
      return <ProfilePictureComment data={data} />;
    }
  };

  function DefaultPPComment() {
    return (
      <img
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        className="rounded-full w-10 h-10"
      />
    );
  }

  const ProfilePictureComment = ({ data }) => {
    return (
      <img
        src={data.picture}
        alt="profilepicture"
        className="rounded-full w-10 h-10"
      />
    );
  };

  const SetReplyCommentProfilePicture = ({ data }) => {
    const isNull = data.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPPReplyComment />;
    } else {
      return <ProfilePictureReplyComment data={data} />;
    }
  };

  function DefaultPPReplyComment() {
    return (
      <img
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        className="rounded-full w-7 h-7"
      />
    );
  }

  const ProfilePictureReplyComment = ({ data }) => {
    return (
      <img
        src={data.picture}
        alt="profilepicture"
        className="rounded-full w-7 h-7"
      />
    );
  };

  const SetCommentUsername = ({ data }) => {
    if (data.username === null) {
      return (
        <p
          style={{
            maxWidth: "15vw",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            fontWeight: "bold",
          }}
        >
          {data.name}
        </p>
      );
    } else {
      return (
        <p
          style={{
            maxWidth: "15vw",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            fontWeight: "bold",
          }}
        >
          {data.username}
        </p>
      );
    }
  };

  const handleDeleteComment = async (e) => {
    dispatch4({
      type: "DELETE_REQUEST",
    });
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/deleteComment`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
          data: {
            postId: post.id,
            commentId: e,
          },
        }
      );

      dispatch4({
        type: "DELETE_SUCCESS",
      });
      toast.success("Comment deleted successfully!");
    } catch (error) {
      dispatch4({
        type: "DELETE_FAIL",
      });
      toast.error(getError(error));
    }
  };

  const handleDeleteReplyComment = async (e) => {
    dispatch4({
      type: "DELETE_REQUEST",
    });
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/deleteReplyComment`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
          data: {
            replyId: e.reply_id,
          },
        }
      );

      dispatch4({
        type: "DELETE_SUCCESS",
      });
      toast.success("Comment deleted successfully!");
      //fix
      handleReplyComment(e);
    } catch (error) {
      dispatch4({
        type: "DELETE_FAIL",
      });
      toast.error(getError(error));
    }
  };

  useEffect(() => {
    if (dataReplyComment) {
      handleToCommentClick();
      handleToCommentClickMobile();
    }
  }, [handleReplyCommentButton]);

  useEffect(() => {
    if (dataReplyComment) {
      handleToCommentClick();
      handleToCommentClickMobile();
    }
  }, [handleReplyCommentButton]);

  function handleReplyCommentButton(data) {
    setCommentPlaceholder(`Replying to ${data.username}`);
    setDataReplyComment(data);
  }

  const handleEscape = (event) => {
    if (event.key === "Escape") {
      setCommentPlaceholder("Add your comment...");
      setDataReplyComment(null);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  useEffect(async () => {
    dispatch5({
      type: "FETCHING",
    });

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/getAllContactList`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );

      const socialMediaOptions = data.data.map((item, index) => ({
        value: item.id.toString(),
        label: item.name,
        image: item.image,
        url: item.url,
      }));

      dispatch5({
        type: "FETCHED",
        payload: data.data,
      });

      setSocialMediaOptions(socialMediaOptions);
    } catch (error) {
      dispatch5({
        type: "FETCH_FAILED",
        payload: error.message,
      });
    }
  }, []);

  useEffect(() => {
    if (postDetailId === null) {
      return;
    }
    const fetchData = async () => {
      dispatch6({
        type: "FETCHING",
      });

      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/getSpecificPost?postId=${postDetailId}`,
          {
            auth: {
              username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
              password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
            },
          }
        );

        dispatch6({
          type: "FETCHED",
          payload: data.data[0], // Access the data at index 0 directly
        });
      } catch (error) {
        dispatch6({
          type: "FETCH_FAILED",
          payload: error.message,
        });
      }
    };

    fetchData(); // Call the inner function
  }, [postDetailId]);

  useEffect(() => {
    if (dataSpecificPost && dataSpecificPost.category) {
      setPost(dataSpecificPost);
    }

    const imagess = dataSpecificPost?.images || post?.images || [];
    setSelectedImage(imagess[0] || "../images/default_post_2.png");
  }, [dataSpecificPost, post, loading, loadingDel]);

  function handleCloseModalComment() {
    setShowModalComment(false);
  }

  function handleSignInButtonModalComment() {
    navigate("/signin");
  }

  function handleCancelButtonModalComment() {
    setShowModalComment(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (comment.trim() === "") {
      return;
    }
    if (userInfo === null) {
      setShowModalComment(true);
      return;
    }

    if (isSubmitting) return; // Prevent multiple submissions

    setIsSubmitting(true); // Set submitting state to true before starting the request

    if (dataReplyComment === null) {
      // Handle Comment Submission
      dispatch2({ type: "ADD_REQUEST" });

      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/addComment`,
          {
            postId: post.id,
            comment,
            targetUserId: post.user_id,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        toast.success("Comment added successfully!");
        const comment_id = data.data.commentId;

        if (dataUser.user_id !== post.user_id) {
          await axios.post(
            `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/sendNotif`,
            {
              postId: post.id,
              targetUserId: post.user_id,
              notifNumber: 1,
              comment,
              detailId: comment_id,
            },
            {
              headers: { Authorization: `Bearer ${userInfo.data.token}` },
            }
          );
        }
      } catch (err) {
        toast.error(getError(err));
      } finally {
        setIsSubmitting(false); // Reset the submitting state
        setComment("");
      }
    } else if (dataReplyComment !== null) {
      // Handle Reply Submission
      dispatch7({ type: "ADD_REQUEST" });

      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/addReplyComment`,
          {
            postId: post.id,
            comment,
            commentId: dataReplyComment.comment_id,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        toast.success("Comment replied successfully!");
        const reply_id = data.data.replyId;

        const payload = {
          notifNum: 5,
          commentId: dataReplyComment.comment_id,
          commentOwner: dataReplyComment.user_id,
          replyId: reply_id,
          comment,
        };

        sendNotification(payload);
        //fix
        handleReplyComment(
          dataReplyComment.comment_id,
          dataReplyComment.comment_id
        ); // Refresh the replies
      } catch (err) {
        toast.error(getError(err));
      } finally {
        setIsSubmitting(false); // Reset the submitting state
        setComment("");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
    toCommentRefMobile.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  async function unlikePostClick(postId) {
    if (userInfo !== null) {
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/unlikePost`,
          {
            postId: postId,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        // Update the likes state for the specific post
        setLikes(false);

        // Decrease the total likes count
        setTotalLikes((prevTotalLikes) => Math.max(0, prevTotalLikes - 1));

        toast.success("Unliked successfully!");
      } catch (err) {
        console.log(err);
      }
    }
  }

  async function likePostClick(postId) {
    if (userInfo !== null) {
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/likePost`,
          {
            postId: postId,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        // Update the likes state for the specific post
        setLikes(true);

        // Increase the total likes count
        setTotalLikes((prevTotalLikes) => prevTotalLikes + 1);

        toast.success("Like successfully!");
        sendNotification({ notifNum: 2 });
      } catch (err) { }
    }
  }

  const sendNotification = async (payload) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/sendNotif`,
        {
          postId: post.id,
          targetUserId:
            payload.notifNum === 5
              ? [post.user_id, payload.commentOwner]
              : post.user_id,
          notifNumber: payload.notifNum,
          ...(payload.notifNum === 5 && { replyId: payload.replyId }),
          ...(payload.notifNum === 5 && { comment: payload.comment }),
          // detailId: like_id,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
    } catch (error) { }
  };

  function handleButtonClick(postId) {
    if (likes) {
      unlikePostClick(postId);
    } else {
      likePostClick(postId);
    }
    setAnimate(true);
    setTimeout(() => setAnimate(false), 200);
  }

  useEffect(() => {
    if (!post) {
      return;
    }

    setLikes(post.user_liked);
  }, [post]);

  const autoHyperlink = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    return text.split(urlPattern).map((part, index) =>
      urlPattern.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#F95C3D]"
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  const ReadMore = ({ children }) => {
    const text = children;
    const [showMore, setShowMore] = useState(true);
    const toggleReadMore = () => {
      setShowMore(!showMore);
    };

    if (text.length <= 500) {
      return (
        <p className="whitespace-pre-wrap break-words">{autoHyperlink(text)}</p>
      );
    } else {
      const sliceLimit = 500;
      const endOfSentence = text.lastIndexOf(" ", sliceLimit);
      const displayText = showMore
        ? text.slice(0, endOfSentence) + "..."
        : text;

      return (
        <p className="whitespace-pre-wrap break-words">
          {autoHyperlink(displayText)}
          <span
            onClick={toggleReadMore}
            className="whitespace-nowrap text-sm text-[#F95C3D] cursor-pointer"
          >
            {showMore ? " read more" : " show less"}
          </span>
        </p>
      );
    }
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElPost(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElPost(null);
  };

  const handleButtonReport = () => {
    setShowReportModal(true);
  };

  const handleCancelReport = () => {
    setShowReportModal(false);
    setSelectedReason("");
  };

  async function handleReportPost(postId, reasonId) {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/reportPost`,
        {
          postId: postId,
          reasonId: reasonId,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      toast.success("Post Reported.");
    } catch (error) {
      toast.error(getError(error));
    }
    console.log(`Report reason: ${selectedReason}`);
    setShowReportModal(false);
  }

  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value);
  };

  const modalReportStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    outline: "none",
    borderRadius: "8px",
  };

  function handleOpenUpdate() {
    setAnchorElPost(null);
    setShowModalUpdate(true);
  }

  function handleCloseModalUpdate() {
    setShowModalUpdate(false);
  }
  function handleOpenDelete() {
    setAnchorElPost(null);
    setShowModalDelete(true);
  }

  function handleCloseModalDelete() {
    setShowModalDelete(false);
  }

  const handleCancelButtonModalUpdate = () => {
    setShowModalUpdate(false);
  };
  const handleCancelButtonModalDelete = () => {
    setShowModalDelete(false);
  };

  function handleButtonModalUpdate() {
    navigate("/update_post", { state: { post } });
  }

  const handleButtonModalDelete = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/deletePost/${post.id}`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      toast.success("Post deleted successfully!");
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      toast.error(getError(error));
    }
  };

  const openContact = (contact_id) => {
    let url;
    if (dataAllContactList) {
      if (contact_id) {
        let contact = post.contact.find(
          (item) => item.listcontact_id === contact_id
        );

        if (contact.link) {
          if (
            contact.link.startsWith("http://") ||
            contact.link.startsWith("https://")
          ) {
            url = contact.link.replace(/\s/g, "");
          } else if (
            contact.link.startsWith("08") ||
            contact.link.startsWith("+")
          ) {
            url = "tel:" + contact.link;
          } else {
            url = "https://" + contact.link.replace(/\s/g, "");
          }
          window.open(url);
        } else {
          toast.error("URL not found!");
        }
      } else {
        toast.error("Contact not found!");
      }
    } else {
      toast.error("dataAllContactList not found!");
    }
  };

  const handleCopyLink = () => {
    const postLink = `https://siaphub.com/detail_post?postId=${post.id}`;

    // Copy the link to the clipboard
    navigator.clipboard
      .writeText(postLink)
      .then(() => {
        toast.success("Link copied to clipboard:", postLink);
        // You can provide feedback to the user that the link has been copied if needed
      })
      .catch((err) => {
        toast.error("Unable to copy link to clipboard", err);
        // Handle the error, e.g., show an error message to the user
      });
  };

  const typeNames = {
    1: "Product",
    2: "Service",
    3: "Event",
    4: "Job",
    5: "Insight",
    6: "Education",
  };

  const getTypeName = (postType, sdType) => {
    // if (postType === 5 && sdType.value === 1) {
    //   return "Review"; // Adjust as needed if sdType.value should dynamically change the type
    // } else if (postType === 5 && sdType.value === 2) {
    //   return "Question"; // Adjust as needed for sdType.value === 2
    // } else {
    return typeNames[postType] || "Unknown Type";
    // }
  };

  // useEffect(() => {
  //   if (selectedImageRef.current) {
  //     selectedImageRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //     });
  //   }
  // }, [selectedImage]);

  return post ? (
    <>
      {/* <div className='flex mt-5 hidden lg:flex p-3'>
        <div onClick={goBack} className='flex cursor-pointer' >
          <img className="h-auto max-w-full rounded-lg shadow-none" src="../images/back_icon.png" alt="postImage" />
          <h1 className='ml-4 text-xl text-gray-500 mt-2'>Back</h1>
        </div>
      </div> */}

      {/* Upper part Mobile Version */}
      <div key={post.id} className="w-full lg:hidden p-3">
        <Helmet>
          <title>Detail Post | SiapHub</title>
        </Helmet>

        {/* SetDefaultImage at the top */}
        <div className="w-full items-center justify-center">
          <div
            className="flex w-8 h-8 shadow-md justify-center items-center cursor-pointer py-1 bg-white rounded-lg mb-2 hover:bg-[#F5F5F5]"
            onClick={() => navigate(-1)}
          >
            <svg
              width="30"
              height="26"
              viewBox="0 0 30 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="scale-50"
            >
              <path
                d="M12.8878 25.6637C13.3877 26.128 14.179 26.1092 14.6552 25.6217C15.1313 25.1342 15.112 24.3625 14.6122 23.8981L4.19312 14.2191H28.75C29.4403 14.2191 30 13.6733 30 13C30 12.3268 29.4403 11.7809 28.75 11.7809H4.19295L14.6122 2.10183C15.112 1.63745 15.1312 0.865796 14.6552 0.378272C14.179 -0.109236 13.3877 -0.12801 12.8878 0.336367L0.522983 11.823C0.241433 12.0846 0.0748501 12.4181 0.0232168 12.765C0.00798347 12.841 0 12.9197 0 13C0 13.0806 0.00801652 13.1593 0.0232999 13.2355C0.0750332 13.5823 0.2416 13.9156 0.522983 14.177L12.8878 25.6637Z"
                fill="black"
              />
            </svg>
          </div>
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            className="mySwiper rounded-2xl"
          >
            {imagess.map((media, index) => {
              const isVideo = media.includes("smpost-v-"); // Update this to match your naming convention
              return (
                <SwiperSlide key={index}>
                  <div className="flex justify-center">
                    <div
                      className="w-full h-[50vh] relative bg-[#ffffff] rounded-2xl"
                      style={{
                        border: "0.1px solid gainsboro",
                      }}
                    >
                      {isVideo ? (
                        <video
                          className="w-full h-full object-contain rounded-2xl shadow-none"
                          src={media}
                          controls
                        />
                      ) : (
                        <img
                          className="w-full h-full object-contain rounded-2xl shadow-none"
                          src={media}
                          alt="postImage"
                        />
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          {/* <div className="flex justify-end">
            {post.images && post.images.length > 0 ? (
              // icons mobile
              <div className="flex lg:hidden text-[#C0BFBF] my-4 justify-end ">
                <div className="flex card-icons items-center">
                  <div className="flex">
                    <Tooltip
                      onClick={() => handleButtonClick(post.id)}
                      title="Like"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                          animate ? "scale-150" : ""
                        }`}
                        viewBox="0 0 20 20"
                        fill={likes ? "#FFDD43" : "currentColor"}
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                    </Tooltip>

                    <p className="ml-2">{totalLikes}</p>
                  </div>
                  <div className="flex ml-4">
                    <Tooltip
                      onClick={handleToCommentClickMobile}
                      title="Comment"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </Tooltip>
                    <p className="ml-2">{post.total_comments}</p>
                  </div>
                  <div className="flex ml-4">
                    <Tooltip
                      onClick={handleCopyLink}
                      title="Share Post"
                      className="cursor-pointer"
                    >
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                          fill="currentColor"
                        />
                      </svg>
                    </Tooltip>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div> */}
        </div>

        <div className="w-full items-center justify-center">
          {/* Profile Picture and User Info */}

          <div className="card-detail" ref={toCommentRefMobile}>
            <div className="flex" style={{ justifyContent: "space-between" }}>
              <div className="profilePost flex w-full">
                <div className="flex-none" style={{ width: "4.0em" }}>
                  <SetProfilePicture />
                </div>
                <div
                  className="flex items-center"
                  style={{ justifyContent: "center" }}
                >
                  {userInfo !== null ? (
                    <>
                      {dataUser.user_id === post.user_id ? (
                        <a href={`/${dataUser.username}`}>
                          <SetUsername />
                        </a>
                      ) : (
                        <div
                          onClick={() => handleUsername(post)}
                          style={{ cursor: "pointer" }}
                        >
                          <SetUsername />
                        </div>
                      )}
                    </>
                  ) : (
                    <SetUsername />
                  )}
                </div>
              </div>

              {dataUser.user_id === post.user_id ? (
                <div className="flex items-center">
                  <Tooltip title="Edit Post">
                    <MoreVertSharpIcon
                      onClick={handleOpenUserMenu}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                  <Menu
                    sx={{ mt: "45px" }}
                    id="menu-appbar"
                    anchorEl={anchorElPost}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElPost)}
                    onClose={handleCloseUserMenu}
                    PaperProps={{
                      sx: {
                        borderRadius: "0.5rem",
                      },
                    }}
                  >
                    {edits.map((edit) => (
                      <MenuItem key={edit}>
                        {edit === "Update Post" ? (
                          <button onClick={handleOpenUpdate}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        ) : (
                          <button onClick={handleOpenDelete}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        )}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              ) : (
                ""
              )}
              {dataUser.is_admin === true &&
                dataUser.user_id !== post.user_id &&
                userInfo !== null ? (
                <div className="flex items-center">
                  <Tooltip title="Delete Post">
                    <MoreVertSharpIcon
                      onClick={handleOpenUserMenu}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                  <Menu
                    sx={{ mt: "45px" }}
                    id="menu-appbar"
                    anchorEl={anchorElPost}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElPost)}
                    onClose={handleCloseUserMenu}
                  >
                    {editsAsAdmin.map((editAsAdmin) => (
                      <MenuItem key={editAsAdmin}>
                        {editAsAdmin === "Update Post" ? (
                          <button onClick={handleOpenUpdate}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {editAsAdmin}
                            </Typography>{" "}
                          </button>
                        ) : (
                          <button onClick={handleOpenDelete}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {editAsAdmin}
                            </Typography>{" "}
                          </button>
                        )}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              ) : (
                ""
              )}
              {dataUser.user_id !== post.user_id &&
                dataUser.is_admin !== true &&
                userInfo !== null ? (
                <div className="flex items-center">
                  <Tooltip title="More">
                    <MoreVertSharpIcon
                      onClick={handleOpenUserMenu}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                  <Menu
                    sx={{ mt: "0px" }} // Adjust this value if needed
                    id="menu-appbar"
                    anchorEl={anchorElPost}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    open={Boolean(anchorElPost)}
                    onClose={handleCloseUserMenu}
                    PaperProps={{
                      sx: {
                        borderRadius: "0.5rem",
                      },
                    }}
                  >
                    {editsAsUser.map((edit) => (
                      <MenuItem key={edit}>
                        <button onClick={() => handleButtonReport(post.id)}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            {edit}
                          </Typography>{" "}
                        </button>
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="text-2xl font-medium">{post.posttitle}</div>

            <div className="flex flex-wrap md:flex-nowrap items-center mt-3 font-semibold">
              <div className="text-[#F95C3D] p-1 max-w-max mb-2 md:mb-0">
                {post.sd_post_type === 1
                  ? "Share"
                  : post.sd_post_type === 2
                    ? "Seek"
                    : "Unknown"}
              </div>

              <div className="text-[#F95C3D] p-1 max-w-max mb-2 md:mb-0 md:ml-2">
                {getTypeName(post.post_type, post.sd_post_type)}
              </div>

              <div className="text-[#F95C3D] p-1 max-w-max mb-2 md:mb-0 md:ml-2">
                {post.category.label}
              </div>
            </div>

            {nominal ? (
              <div className="my-3 text-2xl font-semibold">{price}</div>
            ) : null}
            <div className="whitespace-pre-wrap break-words">
              {post.description}
            </div>

            <div className="flex justify-end">
              {post.images && post.images.length > 0 ? (
                // icons mobile
                <div className="flex lg:hidden text-[#C0BFBF] my-4 justify-end ">
                  <div className="flex card-icons items-center">
                    <div className="flex">
                      <Tooltip
                        onClick={() => handleButtonClick(post.id)}
                        title="Like"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                            }`}
                          viewBox="0 0 20 20"
                          fill={likes ? "#FFDD43" : "currentColor"}
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      </Tooltip>

                      <p className="ml-2">{totalLikes}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleToCommentClickMobile}
                        title="Comment"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Tooltip>
                      <p className="ml-2">{post.total_comments}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleCopyLink}
                        title="Share Post"
                        className="cursor-pointer"
                      >
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                            fill="currentColor"
                          />
                        </svg>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>

            {post.tag && Object.keys(post.tag).length > 0 ? (
              <div className="flex rounded-lg mt-3 py-2 overflow-x-auto">
                {Object.keys(post.tag).map((key) => (
                  <div
                    className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                    key={key}
                  >
                    {post.tag[key]}
                  </div>
                ))}
              </div>
            ) : null}

            {post.images && post.images.length > 0 ? (
              <></>
            ) : (
              // icons mobile
              <div className="flex lg:hidden text-[#C0BFBF] my-4 justify-end ">
                <div className="flex px-2 items-center">
                  <div className="flex">
                    <Tooltip
                      onClick={() => handleButtonClick(post.id)}
                      title="Like"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                          }`}
                        viewBox="0 0 20 20"
                        fill={likes ? "#FFDD43" : "currentColor"}
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                    </Tooltip>

                    <p className="ml-2">{totalLikes}</p>
                  </div>
                  <div className="flex ml-4">
                    <Tooltip
                      onClick={handleToCommentClickMobile}
                      title="Comment"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </Tooltip>
                    <p className="ml-2">{post.total_comments}</p>
                  </div>
                  <div className="flex ml-4">
                    <Tooltip
                      onClick={handleCopyLink}
                      title="Share Post"
                      className="cursor-pointer"
                    >
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                          fill="currentColor"
                        />
                      </svg>
                    </Tooltip>
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-end items-center my-5">
              {post.contact && Object.keys(post.contact).length > 0 ? (
                <>
                  <div className="flex items-center">
                    {/* Social Media:{" "} */}
                    <div className="overflow-x-auto flex flex-nowrap items-center">
                      {post.contact &&
                        Object.keys(post.contact).map((contactId) => {
                          const contact = dataAllContactList.find(
                            (item) =>
                              item.id === post.contact[contactId].listcontact_id
                          );
                          return contact ? (
                            <button
                              key={contact.id}
                              onClick={() => openContact(contact.id)}
                            >
                              <img
                                src={
                                  Array.isArray(socialMediaOptions) &&
                                  socialMediaOptions.find(
                                    (option) => option.label === contact.name
                                  )?.image
                                }
                                alt={contact.name}
                                className="lineButton ml-1"
                              />
                            </button>
                          ) : null;
                        })}
                    </div>
                    {post.user_id !== dataUser.user_id && (
                      <div className="divider"></div>
                    )}
                  </div>
                </>
              ) : (
                ""
              )}{" "}
              {post.user_id === dataUser.user_id ? (
                ""
              ) : (
                <>
                  <Tooltip title="Message">
                    <button onClick={handleOpenPersonalChat} className="p-2">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.49993 24.284V30L6.77239 28.6203L13.9153 24.284H20.9997C22.6541 24.284 23.9996 22.9226 23.9996 21.2485V9.10634C23.9996 7.43224 22.6541 6.0708 20.9997 6.0708H2.99995C1.34548 6.0708 0 7.43224 0 9.10634V21.2485C0 22.9226 1.34548 24.284 2.99995 24.284H4.49993ZM2.99995 9.10634H20.9997V21.2485H13.0843L7.49988 24.6392V21.2485H2.99995V9.10634Z"
                          fill="black"
                        />
                        <path
                          d="M27.0006 0H9.00093C7.34646 0 6.00098 1.36144 6.00098 3.03554H24.0007C25.6552 3.03554 27.0006 4.39698 27.0006 6.07108V18.2132C28.6551 18.2132 30.0006 16.8518 30.0006 15.1777V3.03554C30.0006 1.36144 28.6551 0 27.0006 0Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                  </Tooltip>
                </>
              )}
            </div>

            <div className="flex items-center justify-center m-3">
              {post.lat && post.long ? (
                <MapContainer
                  center={[post.lat, post.long]}
                  zoom={13}
                  scrollWheelZoom={true}
                  minZoom={2}
                  maxBounds={bounds}
                  maxBoundsViscosity={1.0}
                  zoomControl={false}
                  className="w-full h-80 rounded-lg"
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <ZoomControl position="topright" />
                  <Marker position={[post.lat, post.long]} />
                </MapContainer>
              ) : (
                <></>
              )}
            </div>

            {/* Comment Mobile Layout */}
            <hr />
            <div className="flex-col flex py-3 lg:hidden">
              <div className="5commentContainer pb-3">
                <div
                  className="w-full"
                  style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  {loadingComments ? (
                    <div className="flex justify-center pt-3 ">
                      <LoadingBox />
                    </div>
                  ) : errorComments ? (
                    <MessageBox severity="error">{errorComments}</MessageBox>
                  ) : (
                    <>
                      {dataComments.length === 0 ? (
                        <div className="flex justify-center mb-3">
                          Be the first one to comment!
                        </div>
                      ) : (
                        dataComments.map((dataComment, index) => (
                          <>
                            <div className="my-2">
                              <div
                                className="flex flex-col"
                                style={{ justifyContent: "space-between" }}
                              >
                                <div className="profileComment flex flex-col">
                                  <div className="flex">
                                    <div className="flex-none mr-2">
                                      <SetCommentProfilePicture
                                        data={dataComment}
                                      />
                                    </div>
                                    <div
                                      className="flex flex-col"
                                      style={{ flex: 1 }}
                                    >
                                      <div className="flex items-center">
                                        {userInfo !== null ? (
                                          <>
                                            {dataUser.user_id ===
                                              dataComment.user_id ? (
                                              <a href={`/${dataUser.username}`}>
                                                <SetCommentUsername
                                                  data={dataComment}
                                                />
                                              </a>
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  handleUsername(dataComment)
                                                }
                                                style={{ cursor: "pointer" }}
                                              >
                                                <SetCommentUsername
                                                  data={dataComment}
                                                />
                                              </div>
                                            )}
                                          </>
                                        ) : (
                                          <SetCommentUsername
                                            data={dataComment}
                                          />
                                        )}
                                        {dataComment.verified ? (
                                          <img
                                            className="ml-2 max-h-6"
                                            alt="verified"
                                            src="../../images/icon_done.png"
                                            style={{
                                              maxWidth: "20px",
                                              maxHeight: "20px",
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                        <div className="flex ml-3 text-xs">
                                          <UploadDate
                                            timestamp={dataComment.created_at}
                                          />
                                        </div>
                                        {post.user_id ===
                                          dataComment.user_id ? (
                                          <div className="flex ml-3 text-xs text-white bg-[#F95C3D] py-1 px-1 rounded-lg">
                                            Author
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        <div style={{ marginLeft: "auto" }}>
                                          {(dataUser.is_admin === true ||
                                            dataUser.user_id ===
                                            dataComment.user_id) &&
                                            userInfo !== null ? (
                                            <Tooltip title="Delete Comment">
                                              <CloseTwoToneIcon
                                                onClick={() =>
                                                  handleDeleteComment(
                                                    dataComment.comment_id
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  color: "darkgrey",
                                                }}
                                              />
                                            </Tooltip>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      <div>
                                        <div className="">
                                          {dataComment.comment}
                                        </div>
                                      </div>
                                      <div
                                        className="flex text-xs text-[#F95C3D] cursor-pointer"
                                        onClick={() =>
                                          handleReplyCommentButton(dataComment)
                                        }
                                      >
                                        Reply
                                      </div>
                                      {dataComment.total_replies > 0 ? (
                                        <>
                                          {visibleReplies[index] ? (
                                            <div
                                              className="text-xs text-gray-400 cursor-pointer mt-2"
                                              onClick={() =>
                                                handleReplyComment(
                                                  dataComment.comment_id,
                                                  index
                                                )
                                              }
                                            >
                                              Hide replies
                                            </div>
                                          ) : (
                                            <div
                                              className="text-xs text-gray-400 cursor-pointer mt-2"
                                              onClick={() => {
                                                handleReplyComment(
                                                  dataComment.comment_id,
                                                  index
                                                );
                                              }}
                                            >
                                              View ({dataComment.total_replies})
                                              replies
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {visibleReplies[index] &&
                              replyComments[dataComment.comment_id] && (
                                <div className="ml-12">
                                  {replyComments[dataComment.comment_id].map(
                                    (dataReplyComment) => (
                                      <>
                                        <div className="my-2">
                                          <div
                                            className="flex flex-col"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div className="profileComment flex mb-2 flex-col">
                                              <div className="flex">
                                                <div className="mr-2">
                                                  <SetReplyCommentProfilePicture
                                                    data={dataReplyComment}
                                                  />
                                                </div>
                                                <div
                                                  className="flex flex-col"
                                                  style={{ flex: 1 }}
                                                >
                                                  <div className="flex items-center">
                                                    {userInfo !== null ? (
                                                      <>
                                                        {dataUser.user_id ===
                                                          dataReplyComment.user_id ? (
                                                          <a
                                                            href={`/${dataUser.username}`}
                                                          >
                                                            <SetCommentUsername
                                                              data={
                                                                dataReplyComment
                                                              }
                                                            />
                                                          </a>
                                                        ) : (
                                                          <div
                                                            onClick={() =>
                                                              handleUsername(
                                                                dataReplyComment
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            <SetCommentUsername
                                                              data={
                                                                dataReplyComment
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </>
                                                    ) : (
                                                      <SetCommentUsername
                                                        data={dataReplyComment}
                                                      />
                                                    )}
                                                    {dataReplyComment.verified ? (
                                                      <img
                                                        className="ml-2 max-h-6"
                                                        alt="verified"
                                                        src="../../images/icon_done.png"
                                                        style={{
                                                          maxWidth: "20px",
                                                          maxHeight: "20px",
                                                        }}
                                                      />
                                                    ) : (
                                                      ""
                                                    )}
                                                    <div className="flex ml-3 text-xs">
                                                      <UploadDate
                                                        timestamp={
                                                          dataReplyComment.created_at
                                                        }
                                                      />
                                                    </div>
                                                    {post.user_id ===
                                                      dataReplyComment.user_id ? (
                                                      <div className="flex ml-3 text-xs text-white bg-[#F95C3D] py-1 px-1 rounded-lg">
                                                        Author
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}

                                                    <div
                                                      style={{
                                                        marginLeft: "auto",
                                                      }}
                                                    >
                                                      {(dataUser.is_admin ===
                                                        true ||
                                                        dataUser.user_id ===
                                                        dataReplyComment.user_id) &&
                                                        userInfo !== null ? (
                                                        <Tooltip title="Delete Comment">
                                                          <CloseTwoToneIcon
                                                            onClick={() =>
                                                              handleDeleteReplyComment(
                                                                dataReplyComment
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "darkgrey",
                                                            }}
                                                          />
                                                        </Tooltip>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <div className="">
                                                      {dataReplyComment.comment}
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="flex text-xs text-[#F95C3D] cursor-pointer"
                                                    onClick={() =>
                                                      handleReplyCommentButton(
                                                        dataReplyComment
                                                      )
                                                    }
                                                  >
                                                    Reply
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )
                                  )}
                                </div>
                              )}
                          </>
                        ))
                      )}
                    </>
                  )}
                </div>

                <Modal
                  open={showModalComment}
                  onClose={handleCloseModalComment}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="modal-notification-style">
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                      style={{
                        marginBottom: "10%",
                        marginTop: "5%",
                        textAlign: "center",
                      }}
                    >
                      Sign in to add comment
                    </Typography>
                    <div className="flex justify-center">
                      <button
                        type="button"
                        className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                        onClick={handleSignInButtonModalComment}
                      >
                        Sign in
                      </button>
                      <button
                        type="button"
                        className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                        onClick={handleCancelButtonModalComment}
                      >
                        Cancel
                      </button>
                    </div>
                  </Box>
                </Modal>
              </div>
              <ShowReplyCommentPreview dataReplyComment={dataReplyComment} />
              <div className="flex lg:hidden">
                <div className="flex-none mr-2">
                  <SetProfilePictureDataUser />
                </div>

                <div
                  className="addCommentContainer rounded-lg pl-3 pr-3 w-full"
                  style={{
                    backgroundColor: "rgb(241 241 241)",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <div
                      className="flex justify-between w-full nav_link"
                      id="comment"
                    >
                      <input
                        type="text"
                        className="w-full outline-none w-full py-2 "
                        value={comment}
                        onChange={handleCommentChange}
                        onKeyDown={handleKeyPress}
                        placeholder={commentPlaceholder}
                        style={{
                          backgroundColor: "rgb(241 241 241)",
                        }}
                        ref={toInputCommentRefMobile}
                      />

                      <div className="flex self-center items-center">
                        <button type="submit" disabled={isSubmitting}>
                          <SendIcon
                            className="ml-2"
                            sx={{ color: "#F95C3D" }}
                          />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Upper part Desktop Version */}

      <div key={post.id} className="w-full hidden lg:flex p-3">
        <Helmet>
          <title>Detail Post | SiapHub</title>
        </Helmet>
        <div className="flex-col w-full">
          <div
            className="flex w-8 h-8 shadow-md sticky top-3 justify-center items-center cursor-pointer py-1 bg-white rounded-lg mb-2 hover:bg-[#F5F5F5]"
            onClick={() => navigate("/")}
          >
            <svg
              width="30"
              height="26"
              viewBox="0 0 30 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="scale-50"
            >
              <path
                d="M12.8878 25.6637C13.3877 26.128 14.179 26.1092 14.6552 25.6217C15.1313 25.1342 15.112 24.3625 14.6122 23.8981L4.19312 14.2191H28.75C29.4403 14.2191 30 13.6733 30 13C30 12.3268 29.4403 11.7809 28.75 11.7809H4.19295L14.6122 2.10183C15.112 1.63745 15.1312 0.865796 14.6552 0.378272C14.179 -0.109236 13.3877 -0.12801 12.8878 0.336367L0.522983 11.823C0.241433 12.0846 0.0748501 12.4181 0.0232168 12.765C0.00798347 12.841 0 12.9197 0 13C0 13.0806 0.00801652 13.1593 0.0232999 13.2355C0.0750332 13.5823 0.2416 13.9156 0.522983 14.177L12.8878 25.6637Z"
                fill="black"
              />
            </svg>
          </div>
          {post.images && post.images.length > 0 ? (
            <div className="flex w-full">
              <div className="w-3/5 mr-3">
                <SetDefaultImage />
              </div>
              <div className="w-2/5 card-detail items-center justify-center">
                <div
                  className="flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="profilePost flex w-full">
                    <div className="" style={{ width: "4.0em" }}>
                      <SetProfilePicture />
                    </div>
                    <div
                      className="flex items-center"
                      style={{ justifyContent: "center" }}
                    >
                      {userInfo !== null ? (
                        <>
                          {dataUser.user_id === post.user_id ? (
                            <a href={`/${dataUser.username}`}>
                              <SetUsername />
                            </a>
                          ) : (
                            <div
                              onClick={() => handleUsername(post)}
                              style={{ cursor: "pointer" }}
                            >
                              <SetUsername />
                            </div>
                          )}
                        </>
                      ) : (
                        <SetUsername />
                      )}
                    </div>
                  </div>
                  {dataUser.user_id === post.user_id && userInfo !== null ? (
                    <div className="flex items-center">
                      <Tooltip title="Edit Post">
                        <MoreVertSharpIcon
                          onClick={handleOpenUserMenu}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElPost}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorElPost)}
                        onClose={handleCloseUserMenu}
                        PaperProps={{
                          sx: {
                            borderRadius: "0.5rem",
                          },
                        }}
                      >
                        {edits.map((edit) => (
                          <MenuItem key={edit}>
                            {edit === "Update Post" ? (
                              <button onClick={handleOpenUpdate}>
                                <Typography
                                  textAlign="center"
                                  className="no-underline text-black"
                                >
                                  {edit}
                                </Typography>{" "}
                              </button>
                            ) : (
                              <button onClick={handleOpenDelete}>
                                <Typography
                                  textAlign="center"
                                  className="no-underline text-black"
                                >
                                  {edit}
                                </Typography>{" "}
                              </button>
                            )}
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>
                  ) : (
                    ""
                  )}
                  {dataUser.is_admin === true &&
                    dataUser.user_id !== post.user_id &&
                    userInfo !== null ? (
                    <div className="flex items-center">
                      <Tooltip title="Delete Post">
                        <MoreVertSharpIcon
                          onClick={handleOpenUserMenu}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                      <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElPost}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={Boolean(anchorElPost)}
                        onClose={handleCloseUserMenu}
                      >
                        {editsAsAdmin.map((editAsAdmin) => (
                          <MenuItem key={editAsAdmin}>
                            {editAsAdmin === "Update Post" ? (
                              <button onClick={handleOpenUpdate}>
                                <Typography
                                  textAlign="center"
                                  className="no-underline text-black"
                                >
                                  {editAsAdmin}
                                </Typography>{" "}
                              </button>
                            ) : (
                              <button onClick={handleOpenDelete}>
                                <Typography
                                  textAlign="center"
                                  className="no-underline text-black"
                                >
                                  {editAsAdmin}
                                </Typography>{" "}
                              </button>
                            )}
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>
                  ) : (
                    ""
                  )}
                  {dataUser.user_id !== post.user_id &&
                    dataUser.is_admin !== true &&
                    userInfo !== null ? (
                    <div className="flex items-center">
                      <Tooltip title="More">
                        <MoreVertSharpIcon
                          onClick={handleOpenUserMenu}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                      <Menu
                        sx={{ mt: "0px" }} // Adjust this value if needed
                        id="menu-appbar"
                        anchorEl={anchorElPost}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        open={Boolean(anchorElPost)}
                        onClose={handleCloseUserMenu}
                        PaperProps={{
                          sx: {
                            borderRadius: "0.5rem",
                          },
                        }}
                      >
                        {editsAsUser.map((edit) => (
                          <MenuItem key={edit}>
                            <button onClick={() => handleButtonReport(post.id)}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="text-2xl">{post.posttitle}</div>

                <div className="flex flex-row items-center mt-3 font-semibold text-lg">
                  <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
                    {post.sd_post_type === 1
                      ? "Share"
                      : post.sd_post_type === 2
                        ? "Seek"
                        : "Unknown"}
                  </div>

                  <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
                    {getTypeName(post.post_type, post.sd_post_type)}
                  </div>

                  <div className="flex text-[#F95C3D] rounded-lg p-1 max-w-max mb-2">
                    {post.category.label}
                  </div>
                </div>

                <div className="flex justify-between">
                  <div>
                    {nominal ? (
                      <div className="my-3 text-2xl font-semibold">{price}</div>
                    ) : null}
                  </div>
                </div>

                <div className="font-medium">
                  <div>
                    <ReadMore>{post.description}</ReadMore>
                  </div>
                </div>


                <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
                  <div className="flex card-icons items-center">
                    <div className="flex">
                      <Tooltip
                        onClick={() => handleButtonClick(post.id)}
                        title="Like"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                            }`}
                          viewBox="0 0 20 20"
                          fill={likes ? "#FFDD43" : "currentColor"}
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      </Tooltip>

                      <p className="ml-2">{totalLikes}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleToCommentClick}
                        title="Comment"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Tooltip>
                      <p className="ml-2">{post.total_comments}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleCopyLink}
                        title="Share Post"
                        className="cursor-pointer"
                      >
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                            fill="currentColor"
                          />
                        </svg>
                      </Tooltip>
                    </div>
                  </div>
                </div>
                {post.tag && Object.keys(post.tag).length > 0 ? (
                  <div className="flex rounded-lg mt-3 py-2 overflow-x-auto">
                    {Object.keys(post.tag).map((key) => (
                      <div
                        className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                        key={key}
                      >
                        {post.tag[key]}
                      </div>
                    ))}
                  </div>
                ) : null}

                {post.images && post.images.length > 0 ? (
                  <></>
                ) : (
                  // icons desktop
                  <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
                    <div className="flex px-2 items-center">
                      <div className="flex">
                        <Tooltip
                          onClick={() => handleButtonClick(post.id)}
                          title="Like"
                          className="cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                              }`}
                            viewBox="0 0 20 20"
                            fill={likes ? "#FFDD43" : "currentColor"}
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                          </svg>
                        </Tooltip>

                        <p className="ml-2">{totalLikes}</p>
                      </div>
                      <div className="flex ml-4">
                        <Tooltip
                          onClick={handleToCommentClick}
                          title="Comment"
                          className="cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </Tooltip>
                        <p className="ml-2">{post.total_comments}</p>
                      </div>
                      <div className="flex ml-4">
                        <Tooltip
                          onClick={handleCopyLink}
                          title="Share Post"
                          className="cursor-pointer"
                        >
                          <svg
                            width="22"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                              fill="currentColor"
                            />
                          </svg>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                )}

                <div className="flex justify-end items-center my-3">
                  {post.contact && Object.keys(post.contact).length > 0 ? (
                    <>
                      <div className="flex items-center">
                        {/* Social Media:{" "} */}
                        <div className="overflow-x-auto flex flex-nowrap items-center">
                          {post.contact &&
                            Object.keys(post.contact).map((contactId) => {
                              const contact = dataAllContactList.find(
                                (item) =>
                                  item.id ===
                                  post.contact[contactId].listcontact_id
                              );
                              return contact ? (
                                <button
                                  key={contact.id}
                                  onClick={() => openContact(contact.id)}
                                  className="inline-flex items-center"
                                >
                                  <img
                                    src={
                                      Array.isArray(socialMediaOptions) &&
                                      socialMediaOptions.find(
                                        (option) =>
                                          option.label === contact.name
                                      )?.image
                                    }
                                    alt={contact.name}
                                    className="lineButton ml-1"
                                  />
                                </button>
                              ) : null;
                            })}
                        </div>
                        {post.user_id !== dataUser.user_id && (
                          <div className="divider"></div>
                        )}
                      </div>
                    </>
                  ) : (
                    ""
                  )}{" "}
                  {post.user_id !== dataUser.user_id && (
                    <>
                      <Tooltip title="Message">
                        <button
                          onClick={handleOpenPersonalChat}
                          className="p-2"
                        >
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.49993 24.284V30L6.77239 28.6203L13.9153 24.284H20.9997C22.6541 24.284 23.9996 22.9226 23.9996 21.2485V9.10634C23.9996 7.43224 22.6541 6.0708 20.9997 6.0708H2.99995C1.34548 6.0708 0 7.43224 0 9.10634V21.2485C0 22.9226 1.34548 24.284 2.99995 24.284H4.49993ZM2.99995 9.10634H20.9997V21.2485H13.0843L7.49988 24.6392V21.2485H2.99995V9.10634Z"
                              fill="black"
                            />
                            <path
                              d="M27.0006 0H9.00093C7.34646 0 6.00098 1.36144 6.00098 3.03554H24.0007C25.6552 3.03554 27.0006 4.39698 27.0006 6.07108V18.2132C28.6551 18.2132 30.0006 16.8518 30.0006 15.1777V3.03554C30.0006 1.36144 28.6551 0 27.0006 0Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                      </Tooltip>
                    </>
                  )}
                </div>

                {/* Map Desktop Version */}
                <div className="flex items-center justify-center m-3">
                  {post.lat && post.long ? (
                    <MapContainer
                      center={[post.lat, post.long]}
                      zoom={13}
                      scrollWheelZoom={true}
                      minZoom={2}
                      maxBounds={bounds}
                      maxBoundsViscosity={1.0}
                      zoomControl={false}
                      className="w-full h-80 rounded-lg"
                    >
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                      <ZoomControl position="topright" />
                      <Marker position={[post.lat, post.long]} />
                    </MapContainer>
                  ) : (
                    <></>
                  )}
                </div>
                {/* Comments */}
                <div
                  className="card-detail flex-col hidden bg-white m-3 p-3 lg:flex"
                  ref={toCommentRef}
                >
                  <div className="commentContainer pb-3">
                    <div
                      className="w-full"
                      style={{
                        maxHeight: "70vh",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {loadingComments ? (
                        <div className="flex justify-center pt-3 ">
                          <LoadingBox />
                        </div>
                      ) : errorComments ? (
                        <MessageBox severity="error">
                          {errorComments}
                        </MessageBox>
                      ) : (
                        <>
                          {dataComments.length === 0 ? (
                            <div className="flex justify-center mb-3">
                              Be the first one to comment!
                            </div>
                          ) : (
                            dataComments.map((dataComment, index) => (
                              <>
                                <div className="my-2">
                                  <div
                                    className="flex flex-col"
                                    style={{ justifyContent: "space-between" }}
                                  >
                                    <div className="profileComment flex mb-2 flex-col">
                                      <div className="flex">
                                        <div className="mr-2">
                                          <SetCommentProfilePicture
                                            data={dataComment}
                                          />
                                        </div>
                                        <div
                                          className="flex flex-col"
                                          style={{ flex: 1 }}
                                        >
                                          <div className="flex items-center">
                                            {userInfo !== null ? (
                                              <>
                                                {dataUser.user_id ===
                                                  dataComment.user_id ? (
                                                  <a
                                                    href={`/${dataUser.username}`}
                                                  >
                                                    <SetCommentUsername
                                                      data={dataComment}
                                                    />
                                                  </a>
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      handleUsername(
                                                        dataComment
                                                      )
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <SetCommentUsername
                                                      data={dataComment}
                                                    />
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              <SetCommentUsername
                                                data={dataComment}
                                              />
                                            )}
                                            {dataComment.verified ? (
                                              <img
                                                className="ml-2 max-h-6"
                                                alt="verified"
                                                src="../../images/icon_done.png"
                                                style={{
                                                  maxWidth: "20px",
                                                  maxHeight: "20px",
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}
                                            <div className="flex ml-3 text-xs">
                                              <UploadDate
                                                timestamp={
                                                  dataComment.created_at
                                                }
                                              />
                                            </div>
                                            {post.user_id ===
                                              dataComment.user_id ? (
                                              <div className="flex ml-3 text-xs text-white bg-[#F95C3D] py-1 px-1 rounded-lg">
                                                Author
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            <div style={{ marginLeft: "auto" }}>
                                              {(dataUser.is_admin === true ||
                                                dataUser.user_id ===
                                                dataComment.user_id) &&
                                                userInfo !== null ? (
                                                <Tooltip title="Delete Comment">
                                                  <CloseTwoToneIcon
                                                    onClick={() =>
                                                      handleDeleteComment(
                                                        dataComment.comment_id
                                                      )
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "darkgrey",
                                                    }}
                                                  />
                                                </Tooltip>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="">
                                              {dataComment.comment}
                                            </div>
                                          </div>
                                          <div
                                            className="flex text-xs text-[#F95C3D] cursor-pointer"
                                            onClick={() =>
                                              handleReplyCommentButton(
                                                dataComment
                                              )
                                            }
                                          >
                                            Reply
                                          </div>
                                          {dataComment.total_replies > 0 ? (
                                            <>
                                              {visibleReplies[index] ? (
                                                <div
                                                  className="text-xs text-gray-400 cursor-pointer mt-2"
                                                  onClick={() =>
                                                    handleReplyComment(
                                                      dataComment.comment_id,
                                                      index
                                                    )
                                                  }
                                                >
                                                  Hide replies
                                                </div>
                                              ) : (
                                                <div
                                                  className="text-xs text-gray-400 cursor-pointer mt-2"
                                                  onClick={() => {
                                                    handleReplyComment(
                                                      dataComment.comment_id,
                                                      index
                                                    );
                                                  }}
                                                >
                                                  View (
                                                  {dataComment.total_replies})
                                                  replies
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {visibleReplies[index] &&
                                  replyComments[dataComment.comment_id] && (
                                    <div className="ml-12">
                                      {replyComments[
                                        dataComment.comment_id
                                      ].map((dataReplyComment) => (
                                        <>
                                          <div className="my-2">
                                            <div
                                              className="flex flex-col"
                                              style={{
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <div className="profileComment flex mb-2 flex-col">
                                                <div className="flex">
                                                  <div className="mr-2">
                                                    <SetReplyCommentProfilePicture
                                                      data={dataReplyComment}
                                                    />
                                                  </div>
                                                  <div
                                                    className="flex flex-col"
                                                    style={{ flex: 1 }}
                                                  >
                                                    <div className="flex items-center">
                                                      {userInfo !== null ? (
                                                        <>
                                                          {dataUser.user_id ===
                                                            dataReplyComment.user_id ? (
                                                            <a
                                                              href={`/${dataUser.username}`}
                                                            >
                                                              <SetCommentUsername
                                                                data={
                                                                  dataReplyComment
                                                                }
                                                              />
                                                            </a>
                                                          ) : (
                                                            <div
                                                              onClick={() =>
                                                                handleUsername(
                                                                  dataReplyComment
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                            >
                                                              <SetCommentUsername
                                                                data={
                                                                  dataReplyComment
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                        </>
                                                      ) : (
                                                        <SetCommentUsername
                                                          data={
                                                            dataReplyComment
                                                          }
                                                        />
                                                      )}
                                                      {dataReplyComment.verified ? (
                                                        <img
                                                          className="ml-2 max-h-6"
                                                          alt="verified"
                                                          src="../../images/icon_done.png"
                                                          style={{
                                                            maxWidth: "20px",
                                                            maxHeight: "20px",
                                                          }}
                                                        />
                                                      ) : (
                                                        ""
                                                      )}
                                                      <div className="flex ml-3 text-xs">
                                                        <UploadDate
                                                          timestamp={
                                                            dataReplyComment.created_at
                                                          }
                                                        />
                                                      </div>

                                                      {post.user_id ===
                                                        dataReplyComment.user_id ? (
                                                        <div className="flex ml-3 text-xs text-white bg-[#F95C3D] py-1 px-1 rounded-lg">
                                                          Author
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}

                                                      <div
                                                        style={{
                                                          marginLeft: "auto",
                                                        }}
                                                      >
                                                        {(dataUser.is_admin ===
                                                          true ||
                                                          dataUser.user_id ===
                                                          dataReplyComment.user_id) &&
                                                          userInfo !== null ? (
                                                          <Tooltip title="Delete Comment">
                                                            <CloseTwoToneIcon
                                                              onClick={() =>
                                                                handleDeleteReplyComment(
                                                                  dataReplyComment
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color:
                                                                  "darkgrey",
                                                              }}
                                                            />
                                                          </Tooltip>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                    <div>
                                                      <div className="">
                                                        {
                                                          dataReplyComment.comment
                                                        }
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="flex text-xs text-[#F95C3D] cursor-pointer"
                                                      onClick={() =>
                                                        handleReplyCommentButton(
                                                          dataReplyComment
                                                        )
                                                      }
                                                    >
                                                      Reply
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ))}
                                    </div>
                                  )}
                              </>
                            ))
                          )}
                        </>
                      )}
                    </div>

                    <Modal
                      open={showModalComment}
                      onClose={handleCloseModalComment}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box className="modal-notification-style">
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          style={{
                            marginBottom: "10%",
                            marginTop: "5%",
                            textAlign: "center",
                          }}
                        >
                          Sign in to add comment
                        </Typography>
                        <div className="flex justify-center">
                          <button
                            type="button"
                            className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                            onClick={handleSignInButtonModalComment}
                          >
                            Sign in
                          </button>
                          <button
                            type="button"
                            className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                            onClick={handleCancelButtonModalComment}
                          >
                            Cancel
                          </button>
                        </div>
                      </Box>
                    </Modal>
                  </div>
                  <ShowReplyCommentPreview
                    dataReplyComment={dataReplyComment}
                  />
                  <div className="w-full hidden lg:flex">
                    <div className="flex items-center mr-2 flex-none">
                      <SetProfilePictureDataUser />
                    </div>

                    <div
                      className="addCommentContainer rounded-lg pl-3 pr-3 w-full"
                      style={{
                        backgroundColor: "rgb(241 241 241)",
                      }}
                    >
                      <form onSubmit={handleSubmit}>
                        <div
                          className="flex justify-between w-full nav_link"
                          id="comment"
                        >
                          <input
                            type="text"
                            className="w-full outline-none w-full py-2 "
                            value={comment}
                            onChange={handleCommentChange}
                            onKeyDown={handleKeyPress}
                            placeholder={commentPlaceholder}
                            style={{
                              backgroundColor: "rgb(241 241 241)",
                            }}
                            ref={toInputCommentRef}
                          />

                          <div className="flex self-center items-center">
                            <button type="submit" disabled={isSubmitting}>
                              <SendIcon
                                className="ml-2"
                                sx={{ color: "#F95C3D" }}
                              />
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-full card-detail items-center justify-center">
              <div className="flex" style={{ justifyContent: "space-between" }}>
                <div className="profilePost flex w-full">
                  <div className="" style={{ width: "4.0em" }}>
                    <SetProfilePicture />
                  </div>
                  <div
                    className="flex items-center"
                    style={{ justifyContent: "center" }}
                  >
                    {userInfo !== null ? (
                      <>
                        {dataUser.user_id === post.user_id ? (
                          <a href={`/${dataUser.username}`}>
                            <SetUsername />
                          </a>
                        ) : (
                          <div
                            onClick={() => handleUsername(post)}
                            style={{ cursor: "pointer" }}
                          >
                            <SetUsername />
                          </div>
                        )}
                      </>
                    ) : (
                      <SetUsername />
                    )}
                  </div>
                </div>
                {dataUser.user_id === post.user_id && userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="Edit Post">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "45px" }}
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {edits.map((edit) => (
                        <MenuItem key={edit}>
                          {edit === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          )}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.is_admin === true &&
                  dataUser.user_id !== post.user_id &&
                  userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="Delete Post">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "45px" }}
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                    >
                      {editsAsAdmin.map((editAsAdmin) => (
                        <MenuItem key={editAsAdmin}>
                          {editAsAdmin === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          )}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.user_id !== post.user_id &&
                  dataUser.is_admin !== true &&
                  userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="More">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {editsAsUser.map((edit) => (
                        <MenuItem key={edit}>
                          <button onClick={() => handleButtonReport(post.id)}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="text-2xl">{post.posttitle}</div>

              <div className="flex flex-row items-center mt-3 font-semibold text-lg">
                <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
                  {post.sd_post_type === 1
                    ? "Share"
                    : post.sd_post_type === 2
                      ? "Seek"
                      : "Unknown"}
                </div>

                <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
                  {getTypeName(post.post_type, post.sd_post_type)}
                </div>

                <div className="flex text-[#F95C3D] rounded-lg p-1 max-w-max mb-2">
                  {post.category.label}
                </div>
              </div>

              <div className="flex justify-between">
                <div>
                  {nominal ? (
                    <div className="my-3 text-2xl font-semibold">{price}</div>
                  ) : null}
                </div>
              </div>

              <div className="font-medium">
                <div>
                  <ReadMore>{post.description}</ReadMore>
                </div>
              </div>

              {post.tag && Object.keys(post.tag).length > 0 ? (
                <div className="flex rounded-lg mt-3 py-2 overflow-x-auto">
                  {Object.keys(post.tag).map((key) => (
                    <div
                      className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                      key={key}
                    >
                      {post.tag[key]}
                    </div>
                  ))}
                </div>
              ) : null}

              {post.images && post.images.length > 0 ? (
                <></>
              ) : (
                // icons desktop
                <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
                  <div className="flex px-2 items-center">
                    <div className="flex">
                      <Tooltip
                        onClick={() => handleButtonClick(post.id)}
                        title="Like"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                            }`}
                          viewBox="0 0 20 20"
                          fill={likes ? "#FFDD43" : "currentColor"}
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      </Tooltip>

                      <p className="ml-2">{totalLikes}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleToCommentClick}
                        title="Comment"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Tooltip>
                      <p className="ml-2">{post.total_comments}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleCopyLink}
                        title="Share Post"
                        className="cursor-pointer"
                      >
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                            fill="currentColor"
                          />
                        </svg>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex justify-end items-center my-3">
                {post.contact && Object.keys(post.contact).length > 0 ? (
                  <>
                    <div className="flex items-center">
                      {/* Social Media:{" "} */}
                      <div className="overflow-x-auto flex flex-nowrap items-center">
                        {post.contact &&
                          Object.keys(post.contact).map((contactId) => {
                            const contact = dataAllContactList.find(
                              (item) =>
                                item.id ===
                                post.contact[contactId].listcontact_id
                            );
                            return contact ? (
                              <button
                                key={contact.id}
                                onClick={() => openContact(contact.id)}
                                className="inline-flex items-center"
                              >
                                <img
                                  src={
                                    Array.isArray(socialMediaOptions) &&
                                    socialMediaOptions.find(
                                      (option) => option.label === contact.name
                                    )?.image
                                  }
                                  alt={contact.name}
                                  className="lineButton ml-1"
                                />
                              </button>
                            ) : null;
                          })}
                      </div>
                      {post.user_id !== dataUser.user_id && (
                        <div className="divider"></div>
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}{" "}
                {post.user_id !== dataUser.user_id && (
                  <>
                    <Tooltip title="Message">
                      <button onClick={handleOpenPersonalChat} className="p-2">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.49993 24.284V30L6.77239 28.6203L13.9153 24.284H20.9997C22.6541 24.284 23.9996 22.9226 23.9996 21.2485V9.10634C23.9996 7.43224 22.6541 6.0708 20.9997 6.0708H2.99995C1.34548 6.0708 0 7.43224 0 9.10634V21.2485C0 22.9226 1.34548 24.284 2.99995 24.284H4.49993ZM2.99995 9.10634H20.9997V21.2485H13.0843L7.49988 24.6392V21.2485H2.99995V9.10634Z"
                            fill="black"
                          />
                          <path
                            d="M27.0006 0H9.00093C7.34646 0 6.00098 1.36144 6.00098 3.03554H24.0007C25.6552 3.03554 27.0006 4.39698 27.0006 6.07108V18.2132C28.6551 18.2132 30.0006 16.8518 30.0006 15.1777V3.03554C30.0006 1.36144 28.6551 0 27.0006 0Z"
                            fill="black"
                          />
                        </svg>
                      </button>
                    </Tooltip>
                  </>
                )}
              </div>

              {/* Map Desktop Version */}
              <div className="flex items-center justify-center m-3">
                {post.lat && post.long ? (
                  <MapContainer
                    center={[post.lat, post.long]}
                    zoom={13}
                    scrollWheelZoom={true}
                    minZoom={2}
                    maxBounds={bounds}
                    maxBoundsViscosity={1.0}
                    zoomControl={false}
                    className="w-full h-80 rounded-lg"
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <ZoomControl position="topright" />
                    <Marker position={[post.lat, post.long]} />
                  </MapContainer>
                ) : (
                  <></>
                )}
              </div>
              {/* Comments */}
              <div
                className="card-detail flex-col hidden bg-white m-3 p-3 lg:flex"
                ref={toCommentRef}
              >
                <div className="commentContainer pb-3">
                  <div
                    className="w-full"
                    style={{
                      maxHeight: "70vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {loadingComments ? (
                      <div className="flex justify-center pt-3 ">
                        <LoadingBox />
                      </div>
                    ) : errorComments ? (
                      <MessageBox severity="error">{errorComments}</MessageBox>
                    ) : (
                      <>
                        {dataComments.length === 0 ? (
                          <div className="flex justify-center mb-3">
                            Be the first one to comment!
                          </div>
                        ) : (
                          dataComments.map((dataComment, index) => (
                            <>
                              <div className="my-2">
                                <div
                                  className="flex flex-col"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <div className="profileComment flex mb-2 flex-col">
                                    <div className="flex">
                                      <div className="mr-2">
                                        <SetCommentProfilePicture
                                          data={dataComment}
                                        />
                                      </div>
                                      <div
                                        className="flex flex-col"
                                        style={{ flex: 1 }}
                                      >
                                        <div className="flex items-center">
                                          {userInfo !== null ? (
                                            <>
                                              {dataUser.user_id ===
                                                dataComment.user_id ? (
                                                <a
                                                  href={`/${dataUser.username}`}
                                                >
                                                  <SetCommentUsername
                                                    data={dataComment}
                                                  />
                                                </a>
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    handleUsername(dataComment)
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <SetCommentUsername
                                                    data={dataComment}
                                                  />
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            <SetCommentUsername
                                              data={dataComment}
                                            />
                                          )}
                                          {dataComment.verified ? (
                                            <img
                                              className="ml-2 max-h-6"
                                              alt="verified"
                                              src="../../images/icon_done.png"
                                              style={{
                                                maxWidth: "20px",
                                                maxHeight: "20px",
                                              }}
                                            />
                                          ) : (
                                            ""
                                          )}
                                          <div className="flex ml-3 text-xs">
                                            <UploadDate
                                              timestamp={dataComment.created_at}
                                            />
                                          </div>
                                          {post.user_id ===
                                            dataComment.user_id ? (
                                            <div className="flex ml-3 text-xs text-white bg-[#F95C3D] py-1 px-1 rounded-lg">
                                              Author
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          <div style={{ marginLeft: "auto" }}>
                                            {(dataUser.is_admin === true ||
                                              dataUser.user_id ===
                                              dataComment.user_id) &&
                                              userInfo !== null ? (
                                              <Tooltip title="Delete Comment">
                                                <CloseTwoToneIcon
                                                  onClick={() =>
                                                    handleDeleteComment(
                                                      dataComment.comment_id
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "darkgrey",
                                                  }}
                                                />
                                              </Tooltip>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="">
                                            {dataComment.comment}
                                          </div>
                                        </div>
                                        <div
                                          className="flex text-xs text-[#F95C3D] cursor-pointer"
                                          onClick={() =>
                                            handleReplyCommentButton(
                                              dataComment
                                            )
                                          }
                                        >
                                          Reply
                                        </div>
                                        {dataComment.total_replies > 0 ? (
                                          <>
                                            {visibleReplies[index] ? (
                                              <div
                                                className="text-xs text-gray-400 cursor-pointer mt-2"
                                                onClick={() =>
                                                  handleReplyComment(
                                                    dataComment.comment_id,
                                                    index
                                                  )
                                                }
                                              >
                                                Hide replies
                                              </div>
                                            ) : (
                                              <div
                                                className="text-xs text-gray-400 cursor-pointer mt-2"
                                                onClick={() => {
                                                  handleReplyComment(
                                                    dataComment.comment_id,
                                                    index
                                                  );
                                                }}
                                              >
                                                View (
                                                {dataComment.total_replies})
                                                replies
                                              </div>
                                            )}
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {visibleReplies[index] &&
                                replyComments[dataComment.comment_id] && (
                                  <div className="ml-12">
                                    {replyComments[dataComment.comment_id].map(
                                      (dataReplyComment) => (
                                        <>
                                          <div className="my-2">
                                            <div
                                              className="flex flex-col"
                                              style={{
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <div className="profileComment flex mb-2 flex-col">
                                                <div className="flex">
                                                  <div className="mr-2">
                                                    <SetReplyCommentProfilePicture
                                                      data={dataReplyComment}
                                                    />
                                                  </div>
                                                  <div
                                                    className="flex flex-col"
                                                    style={{ flex: 1 }}
                                                  >
                                                    <div className="flex items-center">
                                                      {userInfo !== null ? (
                                                        <>
                                                          {dataUser.user_id ===
                                                            dataReplyComment.user_id ? (
                                                            <a
                                                              href={`/${dataUser.username}`}
                                                            >
                                                              <SetCommentUsername
                                                                data={
                                                                  dataReplyComment
                                                                }
                                                              />
                                                            </a>
                                                          ) : (
                                                            <div
                                                              onClick={() =>
                                                                handleUsername(
                                                                  dataReplyComment
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                            >
                                                              <SetCommentUsername
                                                                data={
                                                                  dataReplyComment
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                        </>
                                                      ) : (
                                                        <SetCommentUsername
                                                          data={
                                                            dataReplyComment
                                                          }
                                                        />
                                                      )}
                                                      {dataReplyComment.verified ? (
                                                        <img
                                                          className="ml-2 max-h-6"
                                                          alt="verified"
                                                          src="../../images/icon_done.png"
                                                          style={{
                                                            maxWidth: "20px",
                                                            maxHeight: "20px",
                                                          }}
                                                        />
                                                      ) : (
                                                        ""
                                                      )}
                                                      <div className="flex ml-3 text-xs">
                                                        <UploadDate
                                                          timestamp={
                                                            dataReplyComment.created_at
                                                          }
                                                        />
                                                      </div>

                                                      {post.user_id ===
                                                        dataReplyComment.user_id ? (
                                                        <div className="flex ml-3 text-xs text-white bg-[#F95C3D] py-1 px-1 rounded-lg">
                                                          Author
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}

                                                      <div
                                                        style={{
                                                          marginLeft: "auto",
                                                        }}
                                                      >
                                                        {(dataUser.is_admin ===
                                                          true ||
                                                          dataUser.user_id ===
                                                          dataReplyComment.user_id) &&
                                                          userInfo !== null ? (
                                                          <Tooltip title="Delete Comment">
                                                            <CloseTwoToneIcon
                                                              onClick={() =>
                                                                handleDeleteReplyComment(
                                                                  dataReplyComment
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color:
                                                                  "darkgrey",
                                                              }}
                                                            />
                                                          </Tooltip>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                    <div>
                                                      <div className="">
                                                        {
                                                          dataReplyComment.comment
                                                        }
                                                      </div>
                                                    </div>
                                                    <div
                                                      className="flex text-xs text-[#F95C3D] cursor-pointer"
                                                      onClick={() =>
                                                        handleReplyCommentButton(
                                                          dataReplyComment
                                                        )
                                                      }
                                                    >
                                                      Reply
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )
                                    )}
                                  </div>
                                )}
                            </>
                          ))
                        )}
                      </>
                    )}
                  </div>

                  <Modal
                    open={showModalComment}
                    onClose={handleCloseModalComment}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box className="modal-notification-style">
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{
                          marginBottom: "10%",
                          marginTop: "5%",
                          textAlign: "center",
                        }}
                      >
                        Sign in to add comment
                      </Typography>
                      <div className="flex justify-center">
                        <button
                          type="button"
                          className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                          onClick={handleSignInButtonModalComment}
                        >
                          Sign in
                        </button>
                        <button
                          type="button"
                          className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                          onClick={handleCancelButtonModalComment}
                        >
                          Cancel
                        </button>
                      </div>
                    </Box>
                  </Modal>
                </div>
                <ShowReplyCommentPreview dataReplyComment={dataReplyComment} />
                <div className="w-full hidden lg:flex">
                  <div className="flex items-center mr-2 flex-none">
                    <SetProfilePictureDataUser />
                  </div>

                  <div
                    className="addCommentContainer rounded-lg pl-3 pr-3 w-full"
                    style={{
                      backgroundColor: "rgb(241 241 241)",
                    }}
                  >
                    <form onSubmit={handleSubmit}>
                      <div
                        className="flex justify-between w-full nav_link"
                        id="comment"
                      >
                        <input
                          type="text"
                          className="w-full outline-none w-full py-2 "
                          value={comment}
                          onChange={handleCommentChange}
                          onKeyDown={handleKeyPress}
                          placeholder={commentPlaceholder}
                          style={{
                            backgroundColor: "rgb(241 241 241)",
                          }}
                          ref={toInputCommentRef}
                        />

                        <div className="flex self-center items-center">
                          <button type="submit" disabled={isSubmitting}>
                            <SendIcon
                              className="ml-2"
                              sx={{ color: "#F95C3D" }}
                            />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal Confirmation Update */}
      <Modal
        open={showModalUpdate}
        onClose={handleCloseModalUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Are you sure want to update this post?
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleButtonModalUpdate}
            >
              Update
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalUpdate}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {/* Modal Confirmation Delete */}
      <Modal
        open={showModalDelete}
        onClose={handleCloseModalDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Are you sure want to delete this post?
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleButtonModalDelete}
            >
              Delete
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalDelete}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {/* Modal Confirmation Report */}
      <Modal
        open={showReportModal}
        onClose={handleCancelReport}
        aria-labelledby="report-post-title"
        aria-describedby="report-post-description"
      >
        <Box sx={modalReportStyle}>
          <Typography id="report-post-title" variant="h6" component="h2">
            Reason to report post
          </Typography>
          <RadioGroup
            aria-labelledby="report-post-reasons"
            name="report-reasons"
            value={selectedReason}
            onChange={handleReasonChange}
            sx={{ mt: 2 }}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Inappropriate"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Scam Posts"
            />
            <FormControlLabel value="3" control={<Radio />} label="Spam" />
            <FormControlLabel
              value="4"
              control={<Radio />}
              label="Hate Speech"
            />
            <FormControlLabel value="5" control={<Radio />} label="Violence" />
            <FormControlLabel value="6" control={<Radio />} label="Other" />
          </RadioGroup>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button onClick={handleCancelReport} sx={{ mr: 2 }}>
              Cancel Report
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleReportPost(post.id, selectedReason)}
              disabled={!selectedReason}
            >
              Report Post
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  ) : (
    <></>
  );
}

export default DetailPost;
